import { useState } from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { FunnelIcon } from "@heroicons/react/24/outline";
import { carrierOptions } from "../../../../constants";

interface CarrierFilterProps {
  selectedCarriers: string[];
  onChange: (carriers: string[]) => void;
}

export default function CarrierFilter({
  selectedCarriers,
  onChange,
}: CarrierFilterProps) {
  const [draftCarriers, setDraftCarriers] = useState(selectedCarriers);

  const toggleCarrier = (carrier: string) =>
    setDraftCarriers((prev) =>
      prev.includes(carrier)
        ? prev.filter((c) => c !== carrier)
        : [...prev, carrier],
    );

  return (
    <Popover>
      <PopoverButton
        onClick={() => setDraftCarriers(selectedCarriers)}
        className="flex h-10 items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 text-sm font-medium text-gray-950 outline-none cursor-pointer hover:bg-gray-50 focus:ring-2 focus:ring-blue-500"
      >
        <FunnelIcon className="size-4 text-gray-500" />
        Carriers
        <ChevronDownIcon className="size-4 text-gray-500" />
      </PopoverButton>

      <PopoverPanel
        anchor="bottom start"
        className="mt-1 w-56 rounded-xl border border-gray-200 bg-white p-2 shadow-lg outline-none z-20"
      >
        {({ close }) => (
          <>
            <div className="flex max-h-48 flex-col overflow-y-auto">
              {carrierOptions.map((carrier) => (
                <label
                  key={carrier}
                  className="flex cursor-pointer select-none items-center gap-3 rounded-lg px-3 py-2 text-sm text-gray-950 hover:bg-blue-50"
                >
                  <input
                    type="checkbox"
                    checked={draftCarriers.includes(carrier)}
                    onChange={() => toggleCarrier(carrier)}
                    className="size-4 cursor-pointer accent-blue-600"
                  />
                  {carrier}
                </label>
              ))}
            </div>

            <button
              type="button"
              onClick={() => {
                onChange(draftCarriers);
                close();
              }}
              className="mt-2 h-10 w-full rounded-lg border border-gray-200 text-sm font-medium text-gray-950 hover:bg-gray-50 cursor-pointer transition-colors"
            >
              Apply
            </button>
          </>
        )}
      </PopoverPanel>
    </Popover>
  );
}
